var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  left: 0;\n  padding-right: 0.5rem;\n  position: absolute;\n  top: 0.25rem;\n  width: 100%;\n  z-index: 2;\n'], ['\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  left: 0;\n  padding-right: 0.5rem;\n  position: absolute;\n  top: 0.25rem;\n  width: 100%;\n  z-index: 2;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  width: 100%;\n\n  &:after {\n    background: #ddd;\n    content: \'\';\n    display: block;\n    height: 0;\n    padding-top: 78.616352201257862%;\n    width: 100%;\n  }\n\n  > * {\n    display: block;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n'], ['\n  position: relative;\n  width: 100%;\n\n  &:after {\n    background: #ddd;\n    content: \'\';\n    display: block;\n    height: 0;\n    padding-top: 78.616352201257862%;\n    width: 100%;\n  }\n\n  > * {\n    display: block;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  background-color: #fff;\n  position: relative;\n'], ['\n  background-color: #fff;\n  position: relative;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  background: #d23823;\n  border: 0;\n  color: #fff;\n  display: block;\n  left: 50%;\n  min-width: 150px;\n  padding: 0.5rem 1rem;\n  position: absolute;\n  text-align: center;\n  text-transform: uppercase;\n  top: -8px;\n  transform: translate(-50%, -100%) scale(1);\n  transition: transform 0.15s ease-in-out;\n\n  &:visited {\n    color: #fff;\n  }\n\n  &:hover {\n    color: #fff;\n    text-decoration: none;\n    transform: translate(-50%, -100%) scale(1.1);\n  }\n\n  &:focus {\n    color: #fff;\n  }\n'], ['\n  background: #d23823;\n  border: 0;\n  color: #fff;\n  display: block;\n  left: 50%;\n  min-width: 150px;\n  padding: 0.5rem 1rem;\n  position: absolute;\n  text-align: center;\n  text-transform: uppercase;\n  top: -8px;\n  transform: translate(-50%, -100%) scale(1);\n  transition: transform 0.15s ease-in-out;\n\n  &:visited {\n    color: #fff;\n  }\n\n  &:hover {\n    color: #fff;\n    text-decoration: none;\n    transform: translate(-50%, -100%) scale(1.1);\n  }\n\n  &:focus {\n    color: #fff;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  background: #fff;\n  border: 2px dashed #00a5a9;\n  color: #000;\n  font-size: 0.8rem;\n  left: 50%;\n  max-width: 100%;\n  padding: 0.5rem;\n  position: absolute;\n  text-align: center;\n  top: 15px;\n  transform: translate(-50%, -100%) scale(1);\n  white-space: nowrap;\n  width: auto;\n'], ['\n  background: #fff;\n  border: 2px dashed #00a5a9;\n  color: #000;\n  font-size: 0.8rem;\n  left: 50%;\n  max-width: 100%;\n  padding: 0.5rem;\n  position: absolute;\n  text-align: center;\n  top: 15px;\n  transform: translate(-50%, -100%) scale(1);\n  white-space: nowrap;\n  width: auto;\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  font-size: 0.75rem;\n  padding: 0 0.25rem 0 0.5rem;\n  text-shadow: 0 0 3px #000;\n  text-transform: uppercase;\n'], ['\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  font-size: 0.75rem;\n  padding: 0 0.25rem 0 0.5rem;\n  text-shadow: 0 0 3px #000;\n  text-transform: uppercase;\n']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  font-size: .9rem;\n  margin: 0.5rem 0;\n\n  @media ', ' {\n    font-size: 1rem;\n  }\n'], ['\n  font-size: .9rem;\n  margin: 0.5rem 0;\n\n  @media ', ' {\n    font-size: 1rem;\n  }\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n  color: #888;\n  font-size: .9rem;\n\n  @media ', ' {\n    font-size: 1rem;\n  }\n\n  &:hover {\n    color: #d23823;\n    text-decoration: none;\n  }\n'], ['\n  color: #888;\n  font-size: .9rem;\n\n  @media ', ' {\n    font-size: 1rem;\n  }\n\n  &:hover {\n    color: #d23823;\n    text-decoration: none;\n  }\n']),
    _templateObject10 = _taggedTemplateLiteralLoose(['\n  font-size: 0.75rem;\n'], ['\n  font-size: 0.75rem;\n']),
    _templateObject11 = _taggedTemplateLiteralLoose(['\n  font-size: 0.9rem;\n\n  &:hover {\n    text-decoration: none;\n  }\n'], ['\n  font-size: 0.9rem;\n\n  &:hover {\n    text-decoration: none;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { BREAKPOINTS } from '../Constants';

export var Wrapper = styled.article(_templateObject);

export var Top = styled.div(_templateObject2);

// ImageContainer
// heightToWidthRatio = 1 / 1.272
// card body and image overlap = margin-bottom = (overlap %) * heightToWidthRatio
// image container height = padding-top = heightToWidthRatio * 100%
export var ImageContainer = styled.div(_templateObject3);

export var Body = styled.div(_templateObject4);

export var ValueProp = styled.button(_templateObject5);

export var AdminDate = styled.div(_templateObject6);

export var CardType = styled.div(_templateObject7);

export var PostBody = styled.h1(_templateObject8, BREAKPOINTS.smUp);

export var Location = styled('a')(_templateObject9, BREAKPOINTS.smUp);

export var MerchantInfoComponent = function MerchantInfoComponent(props) {
  var merchant = props.merchant,
      profile = props.profile;

  return React.createElement(
    'div',
    null,
    React.createElement(
      Location,
      {
        target: '_blank',
        href: 'https://www.google.com/maps/dir/Current+Location/' + merchant.get('_geoloc').get('lat') + ',' + merchant.get('_geoloc').get('lng')
      },
      React.createElement('i', {
        style: { color: '#d23823' },
        className: 'fa fa-map-marker mr-1',
        'aria-hidden': 'true'
      }),
      merchant.get('line1'),
      ' ',
      merchant.get('line2') !== '' && merchant.get('line2'),
      ' ',
      merchant.get('line3') !== '' && merchant.get('line3'),
      ',',
      ' ',
      React.createElement(
        'span',
        { className: 'text-capitalize' },
        merchant.get('locality')
      )
    )
  );
};

export var MerchantInfo = styled(MerchantInfoComponent)(_templateObject10);

export var FooterName = styled(Link)(_templateObject11);

MerchantInfo.propTypes = {
  merchant: PropTypes.object.isRequired,
  profile: PropTypes.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/social/SocialCardStyles.js
// module id = 146
// module chunks = 4